var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0919 8.99409C12.0919 8.88911 12.074 8.79084 12.0405 8.70373C12.007 8.61886 11.9467 8.53398 11.8618 8.44911L6.63536 3.22042C6.55495 3.14001 6.46114 3.09981 6.34276 3.09311C6.23109 3.08864 6.13728 3.12884 6.04571 3.21819C5.95413 3.31199 5.90723 3.41027 5.90723 3.51748C5.90723 3.62469 5.9519 3.7185 6.04571 3.8123L11.2297 8.99632L6.04347 14.1803C5.96307 14.2607 5.92286 14.3546 5.91616 14.4729L5.91616 14.4752C5.91616 14.5958 5.9586 14.6851 6.04347 14.77C6.13505 14.8638 6.23109 14.9085 6.3383 14.9085C6.44327 14.9085 6.54155 14.8638 6.63312 14.77L11.8618 9.5413C11.9467 9.45643 12.007 9.36932 12.0405 9.28445C12.074 9.19957 12.0919 9.1013 12.0919 8.99409Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow_right_white.a624e8bacda15be89579477e2d08f7c2.svg";
export { ForwardRef as ReactComponent };